import { useIntl } from '@umijs/max';

// 判断是否为二级页面（需要显示面包屑和操作按钮）
export const isSecondaryPage = (pathname: string): boolean => {
  const segments = pathname.split('/').filter(Boolean);

  // 如果路径包含操作页面标识，则为二级页面
  const operationPages = ['add', 'edit', 'create', 'detail', 'view', 'multiProperty', 'multiPropertyReview'];
  return segments.some(segment => operationPages.includes(segment));
};

// 判断是否为一级菜单页面（只显示标题）
export const isPrimaryPage = (pathname: string): boolean => {
  return !isSecondaryPage(pathname);
};

// 获取页面标题
export const getPageTitle = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) {
    return '欢迎';
  }

  // 简单的路由名称映射
  const routeNameMap: Record<string, string> = {
    'operations': '运营概况',
    'customer': '客户管理',
    'task': '任务管理',
    'myTask': '我的任务',
    'taskSupplement': '任务接单',
    'taskSupplementEdit': '编辑任务接单',
    'statistics': '统计',
    'report': '报告管理',
    'review': '我的审核',
    'activity': '活动管理',
    'finance': '财务管理',
    'platform': '平台维护',
    'system': '系统管理',
    'organization': '机构管理',
    'logs': '操作日志',
    'user': '用户管理',
    'personal': '个人设置',
    'role': '角色管理',
    'permission': '权限管理',
    'menu': '菜单配置',
    'settings': '系统设置',
    'dept': '部门管理',
    'business-sub-type': '业务子类型',
    'form-profile': '表单配置包',
    'cert-recognize-eval': '权属识别评测',
    'reportTemplate': '报告模板配置',
    'commonParams': '通用参数与子项',
    'district': '行政区划管理',
    'netValueSolution': '净值方案',
    'planCustomParams': '自定义参数',
    'ledger': '台账管理',
    'inquiry': '询价台账',
    'inquiryBatch': '批量询价',
    'list': '台账明细',
    'edit': '编辑',
    'add': '新增',
    'create': '新增',
    'detail': '详情',
    'view': '查看'
  };

  // 如果是操作页面，返回操作类型 + 父级菜单名
  const operationPages = ['add', 'edit', 'create', 'detail', 'view'];
  const lastSegment = segments[segments.length - 1];

  if (operationPages.includes(lastSegment)) {
    const parentSegment = segments[segments.length - 2];
    const parentName = routeNameMap[parentSegment] || parentSegment;
    const operationName = routeNameMap[lastSegment] || lastSegment;
    return `${parentName}${operationName}`;
  }

  // 如果是ID，返回编辑 + 父级菜单名
  if (/^\d+$/.test(lastSegment)) {
    const parentSegment = segments[segments.length - 2];
    const parentName = routeNameMap[parentSegment] || parentSegment;
    return `${parentName}编辑`;
  }

  // 对统计页面根据父级显示更具体的标题
  if (lastSegment === 'statistics' && segments.length >= 2) {
    const parentSegment = segments[segments.length - 2];
    if (parentSegment === 'task') {
      return '任务统计';
    }
    if (parentSegment === 'report') {
      return '报告统计';
    }
  }

  // 对台账明细页面特殊处理
  if (lastSegment === 'list' && segments.length >= 2 && segments[segments.length - 2] === 'ledger') {
    return '台账明细';
  }

  // 询价台账列表
  if (lastSegment === 'inquiry' && segments.length >= 2 && segments[segments.length - 2] === 'ledger') {
    return '询价台账';
  }

  // 对台账编辑页面特殊处理
  if (lastSegment === 'edit' && segments.length >= 2 && segments[segments.length - 2] === 'ledger') {
    // 尝试从URL中获取id参数来判断是新增还是编辑
    const urlParams = new URLSearchParams(window.location.search);
    const editId = urlParams.get('id');
    return editId ? '编辑台账' : '新增台账';
  }

  // 返回最后一个段落的名称
  return routeNameMap[segments[segments.length - 1]] || segments[segments.length - 1];
};
